import { render, staticRenderFns } from "./bigItem.vue?vue&type=template&id=17eac6be&scoped=true&"
import script from "./bigItem.vue?vue&type=script&lang=ts&"
export * from "./bigItem.vue?vue&type=script&lang=ts&"
import style0 from "./bigItem.vue?vue&type=style&index=0&id=17eac6be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17eac6be",
  null
  
)

export default component.exports